import styles from "./DownloadButton.module.css";
import { generateDownloadDynamicLink } from "@/_firebase/generateDymaicLink";
import { useRouter } from "next/router";

export default function TraitsAndDimensionsDownloadButton(props: {
  message: string;
}) {
  const router = useRouter();
  return (
    <div className={styles.parent}>
      <p className={styles.message}>{props.message}</p>
      <div
        onClick={() => {
          generateDownloadDynamicLink().then((res) => {
            router.push(res);
          });
        }}
        className={styles.downloadParent}
      >
        <p>Download</p>
      </div>
    </div>
  );
}
